export default [
    {
        'country': 'Q1',
        'country_ar': 'معطيات عامة',
        'country_FR': 'Informations générales ',
    },
    {
        'country': 'Q2',
        'country_ar': 'معطيات مهنية',
        'country_FR': 'Informations professionnelles ',

    },
    {
        'country': 'Q3',
        'country_ar': 'معرفة و تطبيق قانون الشغل في العمل',
        'country_FR': 'Connaissance et application du code de travail ',

    },
    {
        'country': 'Q4',
        'country_ar': 'معطيات حول التغطيات الصحية',
        'country_FR': 'Informations sur la couverture médicale ',

    },
    {
        'country': 'Q5',
        'country_ar': 'الحالة الصحية لجامعة المحار',
        'country_FR': 'Etat de santé de la femme collectrice de palourdes ',

    },
    {
        'country': 'Q6',
        'country_ar': 'العمل الجمعياتي و المدني',
        'country_FR': 'Vie associative et civile',

    },
    {
        'country': 'Q7',
        'country_ar': 'علاقة جامعة المحار بالمنتوج',
        'country_FR': 'Relation avec le produit',

    }

];



// WEBPACK FOOTER //
// ./src/api/equetetype.js